let routes = [
    {
      path: '/demande-reconnaissance-formation',
      component: () => import('../views/DemandeReconnaissanceFormation.vue'),
      props: true
    },
    {
      path: '/demande-reconnaissance-formation/:step',
      component: () => import('../views/DemandeReconnaissanceFormation.vue'),
      props: true
    }
  ]
  
  export default routes;